import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, FileText } from 'lucide-react';

const termosSections = [
  {
    title: '1. Aceitação dos Termos',
    text: 'Ao acessar e utilizar o aplicativo MenoEase ("Serviço"), você concorda com estes Termos de Uso. Caso não concorde com algum dos termos aqui descritos, solicitamos que não utilize o Serviço.',
  },
  {
    title: '2. Descrição do Serviço',
    text: 'O MenoEase é um aplicativo de acompanhamento e bem-estar voltado para mulheres na menopausa. O Serviço oferece funcionalidades como: rastreamento de sintomas e hábitos diários, monitoramento de ciclo menstrual, chat com inteligência artificial para dúvidas sobre menopausa, geração de relatórios de saúde e conteúdo educativo sobre saúde feminina.',
  },
  {
    title: '3. Aviso Médico Importante',
    text: 'O MenoEase não substitui consultas médicas, diagnósticos ou tratamentos profissionais. As informações fornecidas pelo aplicativo, incluindo respostas do chat com IA, têm caráter exclusivamente informativo e educacional. Sempre consulte um profissional de saúde qualificado para decisões médicas.',
  },
  {
    title: '4. Cadastro e Conta',
    text: 'Para utilizar o Serviço, você deve criar uma conta fornecendo informações verdadeiras e atualizadas. Você é responsável por manter a confidencialidade de suas credenciais de acesso e por todas as atividades realizadas em sua conta.',
  },
  {
    title: '5. Planos e Pagamentos',
    text: 'O MenoEase oferece um plano gratuito com funcionalidades básicas e planos pagos (Mensal, Anual e Vitalício) com recursos adicionais. Os valores estão descritos na seção de Planos do aplicativo. Oferecemos garantia de reembolso de 7 dias para todos os planos pagos.',
  },
  {
    title: '6. Cancelamento',
    text: 'Você pode cancelar sua assinatura a qualquer momento, sem cobrança de taxas adicionais. O acesso aos recursos premium permanece ativo até o final do período já pago.',
  },
  {
    title: '7. Propriedade Intelectual',
    text: 'Todo o conteúdo do MenoEase — incluindo textos, imagens, design, código e marca — é protegido por direitos autorais e pertence ao MenoEase ou seus licenciadores. É proibida a reprodução, distribuição ou modificação sem autorização prévia.',
  },
  {
    title: '8. Limitação de Responsabilidade',
    text: 'O MenoEase não se responsabiliza por decisões tomadas com base nas informações fornecidas pelo aplicativo. O Serviço é fornecido "como está", sem garantias de que atenderá a necessidades médicas específicas.',
  },
  {
    title: '9. Alterações nos Termos',
    text: 'Reservamo-nos o direito de atualizar estes Termos periodicamente. Alterações significativas serão comunicadas por e-mail ou notificação no aplicativo. O uso continuado do Serviço após alterações constitui aceitação dos novos termos.',
  },
  {
    title: '10. Contato',
    text: 'Para dúvidas sobre estes Termos de Uso, entre em contato pelo e-mail: contato@menoease.com',
  },
];

const privacidadeSections = [
  {
    title: '1. Dados que Coletamos',
    text: 'Podemos coletar os seguintes tipos de informações: dados de cadastro (nome, e-mail, data de nascimento), dados de saúde (sintomas registrados, ciclo menstrual, qualidade de sono, humor, hábitos de hidratação e exercícios), dados de uso (interações com o app, funcionalidades utilizadas, horários de acesso) e dados de pagamento (processados por provedores terceiros seguros — não armazenamos dados de cartão).',
  },
  {
    title: '2. Como Usamos seus Dados',
    text: 'Utilizamos seus dados para fornecer e personalizar o Serviço, gerar relatórios e insights sobre seus sintomas, alimentar o chat com IA para respostas personalizadas, enviar notificações e lembretes configurados por você, e melhorar o aplicativo com base em dados agregados e anonimizados.',
  },
  {
    title: '3. Dados Sensíveis de Saúde',
    text: 'Reconhecemos que seus dados de saúde são especialmente sensíveis. Por isso: seus dados de saúde são criptografados em trânsito e em repouso, nunca vendemos ou compartilhamos seus dados de saúde com terceiros, o acesso interno é restrito a sistemas automatizados necessários para o funcionamento do app, e você pode exportar ou excluir todos os seus dados a qualquer momento.',
  },
  {
    title: '4. Compartilhamento de Dados',
    text: 'Não vendemos suas informações pessoais. Podemos compartilhar dados apenas com provedores de infraestrutura e hospedagem (para manter o app funcionando), processadores de pagamento (apenas dados necessários para cobrança) e autoridades legais, quando exigido por lei.',
  },
  {
    title: '5. Seus Direitos (LGPD)',
    text: 'Conforme a LGPD, você tem direito a: acessar seus dados pessoais, corrigir dados incompletos ou desatualizados, solicitar a exclusão dos seus dados, revogar consentimento a qualquer momento, solicitar portabilidade dos seus dados, e obter informações sobre com quem seus dados são compartilhados.',
  },
  {
    title: '6. Armazenamento e Segurança',
    text: 'Utilizamos medidas técnicas e organizacionais para proteger seus dados, incluindo criptografia, controle de acesso e monitoramento contínuo. Seus dados são armazenados em servidores seguros com conformidade internacional.',
  },
  {
    title: '7. Retenção de Dados',
    text: 'Mantemos seus dados enquanto sua conta estiver ativa. Após exclusão da conta, seus dados serão removidos em até 30 dias, exceto quando a retenção for exigida por lei.',
  },
  {
    title: '8. Contato do Encarregado (DPO)',
    text: 'Para exercer seus direitos ou esclarecer dúvidas sobre privacidade, entre em contato: privacidade@menoease.com',
  },
];

function LegalPage({ title, icon: Icon, intro, sections }) {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf9' }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #B54183, #BE5791)',
        padding: '40px 24px 32px',
      }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              color: 'rgba(255,255,255,0.8)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 14,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              marginBottom: 20,
            }}
          >
            <ArrowLeft size={18} />
            Voltar ao site
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 44,
              height: 44,
              borderRadius: 12,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Icon size={22} color="white" />
            </div>
            <h1 style={{
              color: 'white',
              fontSize: 28,
              fontWeight: 700,
              fontFamily: "'Outfit', sans-serif",
              margin: 0,
            }}>
              {title}
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '32px 24px 64px' }}>
        <p style={{
          fontSize: 13,
          color: '#9A9A9A',
          fontStyle: 'italic',
          marginBottom: 24,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}>
          Última atualização: Março de 2026
        </p>

        {intro && (
          <p style={{
            fontSize: 15,
            color: '#6B6B6B',
            lineHeight: 1.7,
            marginBottom: 24,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          }}>
            {intro}
          </p>
        )}

        {sections.map((section, i) => (
          <div key={i} style={{ marginBottom: 24 }}>
            <h2 style={{
              fontSize: 17,
              fontWeight: 700,
              color: '#2D2D2D',
              marginBottom: 8,
              fontFamily: "'Outfit', sans-serif",
            }}>
              {section.title}
            </h2>
            <p style={{
              fontSize: 15,
              color: '#6B6B6B',
              lineHeight: 1.7,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
            }}>
              {section.text}
            </p>
          </div>
        ))}

        {/* Footer */}
        <div style={{
          marginTop: 48,
          paddingTop: 24,
          borderTop: '1px solid #E8E4E0',
          textAlign: 'center',
        }}>
          <p style={{
            fontSize: 13,
            color: '#9A9A9A',
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          }}>
            © 2026 MenoEase. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
}

export function TermosPage() {
  return (
    <LegalPage
      title="Termos de Uso"
      icon={FileText}
      sections={termosSections}
    />
  );
}

export function PrivacidadePage() {
  return (
    <LegalPage
      title="Política de Privacidade"
      icon={Shield}
      intro="O MenoEase leva a privacidade dos seus dados a sério. Esta política explica como coletamos, usamos, armazenamos e protegemos suas informações pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018)."
      sections={privacidadeSections}
    />
  );
}
